"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.rtlChars = void 0;
var HEChars = '\u05D0-\u05FF';
var ArabicChars = '\u0600-\u06FF';
var ArabicSupplementChars = '\u0750-\u077F';
var ArabicPresentationFormsAChars = '\uFB50-\uFDFF';
var ArabicPresentationFormsBChars = '\uFE70-\uFEFF';
exports.rtlChars = [
    ArabicChars,
    ArabicSupplementChars,
    ArabicPresentationFormsAChars,
    ArabicPresentationFormsBChars,
    HEChars,
].join('');
